import React, {FC} from "react";
import {Box} from "@mui/material";
import {TwoWheeler} from "@mui/icons-material";

export const FallbackImage: FC = () => (
    <Box
        sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#f0f0f0",
            borderRadius: 1,
        }}
    >
        <TwoWheeler sx={{fontSize: "1.5rem", color: "#ccc"}}/>
    </Box>
);
